import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { groupBy, isNullOrEmpty, translate } from '../../../../utils/util';
import { Input, Card, Collapsible, ScannerCode, Chips, Modal } from '../../../../components/UI/ComponentsUI'
import ContainerService from '../../../../services/ContainerService';

const SpawningContainerAviexp = (props) => {
    const [filterUnload, setFilterUnload] = useState(undefined)
    const [openModal, setOpenModal] = useState(false);

    let container = props.container;
    let filter = props.filter;
    let area = props.area;

    useEffect(() => {
        if ((props.unloadLocations?.length ?? 0) === 0) {
            props.getUnloadLocations();
        }
        // eslint-disable-next-line
    }, []);

    const validateGroupedAviexp = (data, area) => {
        var grouped = groupBy(data.containerItem, "aviexpId");
        var filterPartNumber = area ? filter.partNumberArea : filter.partNumber;

        const dataFilter = [];

        if (!isNullOrEmpty(filterPartNumber)) {
            grouped.forEach(element => {
                var elementFilter = element.value;
                if (elementFilter.find(f => f.partNumber.includes(filterPartNumber))) {
                    dataFilter.push({
                        key: element.key,
                        value: element.value.filter((i) => i.partNumber.includes(filterPartNumber))
                    })
                }
            });

            return dataFilter;
        }

        if (!isNullOrEmpty(filterUnload)) {
            grouped.forEach(element => {
                var elementFilter = element.value;
                if (elementFilter.find(f => f.unloadLocationCode.includes(filterUnload))) {
                    dataFilter.push({
                        key: element.key,
                        value: element.value.filter((i) => i.unloadLocationCode.includes(filterUnload))
                    })
                }
            });

            return dataFilter;
        }
        return grouped;
    }

    const validateGroupedBai = (data, container1) => {
        var grouped = groupBy(data.value, "baiCode");
        var filterPartNumber = container1 ? filter.partNumber1 : filter.partNumber2;

        const dataFilter = [];

        if (!isNullOrEmpty(filterPartNumber)) {
            grouped.forEach(element => {
                var elementFilter = element.value.aviexpPartNumber;
                if (elementFilter.find(f => f.partNumber.includes(filterPartNumber))) {
                    dataFilter.push({
                        key: element.key,
                        value: element.value.aviexpPartNumber.filter((i) => i.partNumber.includes(filterPartNumber))
                    })
                }
            });

            return dataFilter;
        }

        return grouped;
    }

    const transferBaiSpawning = (data, rollback) => {
        data.forEach(element => {
            if (rollback) {
                if (!container.containerItem.find(f => f.id === element.id)) {
                    container.containerItem.push(element);
                    area.containerItem = area.containerItem.filter(f => f.id !== element.id);
                }
            } else if (!area.containerItem.find(f => f.id === element.id)) {
                area.containerItem.push(element);
                container.containerItem = container.containerItem.filter(f => f.id !== element.id);
            }
        });

        props.setContainer({ ...container })
        props.setArea({ ...area })
    }

    const renderBaiItem = (data, area) => {
        return data.value.map(p =>
            <fieldset className='fieldset' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {/* {
                    area && <i onClick={() => transferBaiSpawning([p], true)}
                        className="mdi mdi-36px mdi-arrow-left-bold" style={{ color: "#eb7434" }} />
                } */}
                <div>
                    <div>Partnumber : {p.partNumber}</div>
                    <div>Quantidade : {p.totalQuantity}</div>
                    <div>Etiqueta : {isNullOrEmpty(p.baiCodeItem) ? p.baiCode : p.baiCodeItem}</div>
                </div>
                {
                    !area && <i onClick={() => transferBaiSpawning([p], false)}
                        className="mdi mdi-36px mdi-arrow-right-bold" style={{ color: "#eb7434" }} />
                }
            </fieldset>

        )
    }

    const renderUnloadLocation = () => {
        const union = [...new Set([...container.containerItem, ...area.containerItem])];
        var items = union.filter(f => !isNullOrEmpty(f.unloadLocationCode));
        var group = groupBy(items, "unloadLocationCode").map(f => f.key).sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0));

        return (
            <Chips onClick={(evt) => {
                if (evt !== filterUnload && area?.containerItem && area.containerItem.length > 0) {
                    setOpenModal(true);
                } else {
                    setFilterUnload(evt === filterUnload ? "" : evt)
                }
            }}
                array={group.map((i) => {
                    return { key: i, text: i, selected: i === filterUnload };
                })} />)
    }

    return (
        <div className="row">
            <div className="col s12 m5">
                <Card>
                    Container Desova
                    <div id="getOrigem" className="row" style={{ padding: '10px' }}>
                        <div className="input-field no-padding col s12">
                            <Input
                                required
                                id="name"
                                name='name'
                                maxLength="11"
                                label="Num. Container"
                                type="text"
                                value={filter?.name || ''}
                                onBlur={() => props.searchContainer(true)}
                                onChange={props.onChange}
                            />
                        </div>
                        {
                            container.id > 0 &&
                            <>
                                <div className="input-field no-padding col s6">
                                    <ScannerCode onScanner={(value) => {
                                        filter.partNumber = value;
                                        props.setFilter({ ...filter })
                                    }} />
                                    <Input
                                        id="partNumber"
                                        name='partNumber'
                                        maxLength="11"
                                        placeHolder="Partnumber"
                                        type="text"
                                        value={filter?.partNumber || ''}
                                        onChange={props.onChange}
                                    />
                                </div>
                                {
                                    container.id && <div className="input-field no-padding col s5" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <i style={{ cursor: 'pointer' }}
                                            onClick={() => transferBaiSpawning(container.containerItem, false)}

                                            className="mdi mdi-36px mdi-chevron-triple-right"></i>
                                    </div>
                                }
                                {renderUnloadLocation()}
                            </>

                        }
                    </div>
                    {container && container.containerItem && validateGroupedAviexp(container, false).map((f, index) =>
                        <Collapsible
                            id={index}
                            actions={
                                [
                                    {
                                        func: () => transferBaiSpawning(f.value, false),
                                        actionicon: "mdi mdi-36px mdi-arrow-right-bold",
                                    }
                                ]
                            }
                            close={"true"}
                            header={`Aviexp ${f.key}`}
                            body={
                                validateGroupedBai(f).map((a, index) =>
                                    <Collapsible
                                        id={index}
                                        actions={
                                            [
                                                {
                                                    func: () => transferBaiSpawning(a.value, false),
                                                    actionicon: "mdi mdi-36px mdi-arrow-right-bold",
                                                    actionIconColor: "#349ceb"
                                                }
                                            ]
                                        }
                                        close={"true"}
                                        header={`Nº Caixa ${a.key} / Qtd ${a.value.length}`}
                                        body={renderBaiItem(a, false)}
                                    />
                                )
                            }
                        />
                    )}
                </Card>
            </div>
            {
                container && container.id &&
                <div className="col s12 m5">
                    <Card>
                        Area Desova
                        <div id="getOrigem" className="row" style={{ padding: '10px' }}>
                            {/* <div className="no-padding col s12">
                                <SelectNew
                                    id="unloadLocationId"
                                    name="unloadLocationId"
                                    placeHolder={translate('choose-one-option', 'general')}
                                    label={translate('fields.unloadLocation', 'container')}
                                    data={props.unloadLocations?.map((x) => ({ id: x.id, text: `${x.dock} - ${x.description}` }))}
                                    change={onChange}
                                />
                            </div> */}
                            <div className="input-field no-padding col s5" style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                <i style={{ cursor: 'pointer' }}
                                    onClick={() => transferBaiSpawning(area.containerItem, true)}
                                    className="mdi mdi-36px mdi-chevron-triple-left"></i>
                            </div>
                            <div className="input-field no-padding col s6">
                                <ScannerCode onScanner={(value) => {
                                    filter.partNumberArea = value;
                                    props.setFilter({ ...filter })
                                }} />
                                <Input
                                    id="partNumberArea"
                                    name='partNumberArea'
                                    maxLength="11"
                                    placeHolder="PartNumber"
                                    type="text"
                                    value={filter?.partNumberArea || ''}
                                    onChange={props.onChange}
                                />
                            </div>
                        </div>
                        {area && area.containerItem && validateGroupedAviexp(area, true).map((f, index) =>
                            <Collapsible
                                id={index}
                                actionPosition="left"
                                actions={
                                    [
                                        {
                                            func: () => transferBaiSpawning(f.value, true),
                                            actionicon: "mdi mdi-36px mdi-arrow-left-bold",
                                        }
                                    ]
                                }
                                close={"true"}
                                header={`Aviexp ${f.key}`}
                                body={
                                    validateGroupedBai(f).map((a, index) =>
                                        <Collapsible
                                            id={index}
                                            actionPosition="left"
                                            actions={
                                                [
                                                    {
                                                        func: () => transferBaiSpawning(a.value, true),
                                                        actionicon: "mdi mdi-36px mdi-arrow-left-bold",
                                                        actionIconColor: "#349ceb"
                                                    }
                                                ]
                                            }
                                            close={"true"}
                                            header={`Nº Caixa ${a.key} / Qtd ${a.value.length}`}
                                            body={renderBaiItem(a, true)}
                                        />
                                    )
                                }
                            />
                        )}
                    </Card>

                </div>
            }
            <Modal
                maxHeight='auto'
                open={openModal}
                dismissible={false}
                id="modalContainerAlertUnload"
                btnCancel={translate('cancel', 'general')}
                onConfirm={() => {
                    transferBaiSpawning(area.containerItem, true)
                    setFilterUnload("");
                    setOpenModal(false)
                }}
                onCancel={() => {
                    setOpenModal(false);
                }}
                closeModal={() => {
                    setOpenModal(false);
                }}
                title="Atenção"
                content="Existem Materiais pendentes de confirmação na area de desova, deseja voltá-los para o container?"
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        unloadLocations: state.containerReducer.unloadLocationList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUnloadLocations: () => {
            dispatch(ContainerService.getUnloadLocation(null));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SpawningContainerAviexp));